export default class ApiLoader {
    constructor(scriptSourceUrl, expectedObjectName) {
        this.src = scriptSourceUrl
        this.objectName = expectedObjectName
        this._loading = false
        this._onload = []
    }

    onloadListener(fun) {
        if (typeof fun === 'function') {
            this._onload.push(fun)
        } else {
            console.warn(`Not a function`)
        }
    }

    getApiObject() {
        return this.objectName.split('.').reduce((prev, curr) => {
            return prev ? prev[curr] : undefined
        }, window)
    }

    isReady() { return !!this.getApiObject() }

    _onScriptLoad() {
        this._loading = false
        this._onload = this._onload.filter(fun => {
            fun(this.getApiObject())
            return false
        })
    }

    load() {
        if (this._loading || this.isReady()) {
            return
        }

        this._loading = true

        let tag = document.createElement('script')
        tag.addEventListener('load', () => {
            if (this.isReady()) {
                this._onScriptLoad()
            } else {
                let intval = setInterval(() => {
                    if (this.isReady()) {
                        this._onScriptLoad()
                        clearInterval(intval)
                    }
                }, 50)
            }
        })
        tag.setAttribute('async', 'true')
        tag.setAttribute('defer', 'true')
        tag.src = this.src
        document.head.appendChild(tag)
    }

    api(callback) {
        if (this.isReady()) {
            callback(this.getApiObject())
        } else {
            this._onload.push(callback)
            this.load()
        }
    }
}
